<template>
  <v-app id="portal">
    <v-content class="px-2">
      <v-tabs fixed-tabs>
        <v-tab>
          {{ locale[local].screen.dadosCadastrais.string001 }}
        </v-tab>
        <v-tab v-if="$dadosCadastrais">
          {{ locale[local].screen.dadosCadastrais.string002 }}
        </v-tab>

        <v-tab-item class="ma-2">
          <div v-show="!mostrarFormDadosCadastrais">
            <template>
              <v-card class="mx-auto mt-4" :width="cardWidth">
                <v-row>
                  <v-col cols="12" lg="6" class="my-auto">
                    <cgi-card-imagem-perfil
                      :loading="loading"
                      :nome="txtNome"
                    ></cgi-card-imagem-perfil>
                  </v-col>

                  <v-col cols="12" lg="6">
                    <v-skeleton-loader
                      :loading="loading"
                      transition="scale-transition"
                      :types="{ skeleton: 'list-item-avatar-two-line@6' }"
                      type="skeleton"
                    >
                      <v-list two-line>
                        <template v-for="pData in dadosPessoais">
                          <cgi-cadastro-info-item
                            :key="pData.key"
                            :customData="pData"
                          ></cgi-cadastro-info-item>

                          <v-divider :key="'d' + pData.key" inset></v-divider>
                        </template>
                      </v-list>
                    </v-skeleton-loader>
                  </v-col>
                </v-row>
              </v-card>
            </template>

            <v-btn
              :loading="loadingButton"
              :disabled="loadingButton"
              color="primary"
              class="my-4"
              x-large
              @click="initUpdatePersonalData"
            >
              {{ locale[local].screen.dadosCadastrais.string003 }}
            </v-btn>

            <v-btn
              :loading="loadingButton"
              :disabled="loadingButton"
              color="primary"
              class="my-4 ml-2"
              x-large
              @click="buscaBeneficios"
            >
              {{ locale[local].screen.dadosCadastrais.string004 }}
            </v-btn>
          </div>

          <div v-show="mostrarFormDadosCadastrais">
            <v-container grid-list-md fluid>
              <form-dados-cadastrais
                ref="formDadosCadastrais"
                @esconder-formulario="esconderFormulario"
                @mostrar-alerta="mostrarAlerta"
                @mostrar-mensagem="mostrarMensagem"
              >
              </form-dados-cadastrais>
            </v-container>
          </div>
        </v-tab-item>

        <v-tab-item class="ma-2">
          <template>
            <v-card class="mx-auto mt-4" :width="cardWidth">
              <v-row>
                <v-col cols="12" lg="6" class="my-auto">
                  <cgi-card-imagem-perfil
                    :loading="loading"
                    :nome="txtNome"
                  ></cgi-card-imagem-perfil>
                </v-col>

                <v-col cols="12" lg="6">
                  <v-list two-line>
                    <template v-for="cData in dadosContratuais">
                      <cgi-cadastro-info-item
                        :key="cData.key"
                        :customData="cData"
                      ></cgi-cadastro-info-item>

                      <v-divider :key="'d' + cData.key" inset></v-divider>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </v-card>
          </template>
        </v-tab-item>
      </v-tabs>

      <v-dialog v-model="dialogBeneficios" width="900">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >{{ locale[local].screen.dadosCadastrais.string004 }}
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialogBeneficios = false">{{ locale[local].screen.dadosCadastrais.string005 }}</v-btn>
            
            </v-card-title
          >

          <v-container>
            <v-data-table
              :headers="headers"
              :items="beneficios"
              hide-default-header
              hide-default-footer
              disable-pagination
              class="elevation-1"
            >
            </v-data-table>
          </v-container>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >{{ locale[local].screen.dadosCadastrais.string006 }}</v-card-title
          >

          <v-container>
            <v-row>
              <v-col cols="3">
                <v-icon
                  v-if="dialogTipoMensagem == 'Sucesso'"
                  size="64"
                  color="green"
                  >mdi-check-circle</v-icon
                >
                <v-icon
                  v-else-if="dialogTipoMensagem == 'Alerta'"
                  size="64"
                  color="orange"
                  >mdi-alert</v-icon
                >
                <v-icon v-else size="64" color="red">mdi-close-octagon</v-icon>
              </v-col>

              <v-col cols="9">
                {{ dialogMensagem }}
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="primary" text @click="dialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



      <cgi-alerta ref="alerta" />
    </v-content>
  </v-app>
</template>

<script>
import Service from "@/components/api/Service";
import Util from "@/components/api/Util";
import axios from "axios";
import { locale } from '../locale/locale';

export default {
  data() {
    return {
      // Functions
      service: new Service(),
      util: new Util(),

      // Loaders
      loading: false,
      loadingButton: false,
      dialog: false,
      dialogBeneficios: false,

      //Controllers de Tela
      mostrarFormDadosCadastrais: false,

      //Controllers de Texto
      dialogMensagem: null,
      dialogTipoMensagem: "",

      txtNome: null,

      objActualPersonalData: null,

      dadosPessoais: [],
      dadosContratuais: [],

      headers: [
          { text: locale[window.local].screen.dadosCadastrais.table01.header01, value: 'tipo' },
          { text: locale[window.local].screen.dadosCadastrais.table01.header02, value: 'campo1' },
          { text: locale[window.local].screen.dadosCadastrais.table01.header03, value: 'campo2' },
          { text: locale[window.local].screen.dadosCadastrais.table01.header04, value: 'campo3' },
          { text: locale[window.local].screen.dadosCadastrais.table01.header05, value: 'campo4' },
        ],
        beneficios: [] 
    };
  },
  mounted() {
    this.buscaDadosEmpregado()
  },
  methods: {
    esconderFormulario() {
      this.mostrarFormDadosCadastrais = false;
    },
    mostrarAlerta(mensagem) {
      this.$refs.alerta.mostrarMensagem(mensagem, "red", true);
    },
    mostrarMensagem(mensagem, tipoMensagem) {
      this.dialog = true;
      this.dialogMensagem = mensagem;
      this.dialogTipoMensagem = tipoMensagem;
    },
    async initUpdatePersonalData() {
      try {
        var respostaCadastroPendente = await this.service.verificaCadastroPendente(
          {
            codPessoa: parseInt(localStorage.getItem("codPessoa"))
          }
        );

        if (respostaCadastroPendente.status === 200) {
          if (respostaCadastroPendente.data.retorno[0].estatus === "Erro") {
            throw new Error(
              locale[window.local].screen.dadosCadastrais.error001
            );
          }
        } else {
          throw new Error(
            locale[window.local].screen.dadosCadastrais.error002
          );
        }

        this.loadingButton = true;

        this.$refs.formDadosCadastrais.limparFormulario();
        this.dadosCadastraisFormStep = 1;

        axios
          .all([
            this.service.buscaDadosPessoais({
              codPessoa: parseInt(localStorage.getItem("codPessoa"))
            }),
            this.service.getPublicPlaces(),
            this.service.buscaUfs(),
            this.service.getMaritalStates(),
            this.service.getLevelsOfEducation()
          ])
          .then(
            axios.spread(
              (
                responsePersonalData,
                responsePublicPlaces,
                responseFederatedUnits,
                responseMaritalStates,
                responseLevelsOfEducation
              ) => {
                if (responsePublicPlaces.status === 200) {
                  this.$refs.formDadosCadastrais.publicPlaces =
                    responsePublicPlaces.data.ttLogradouro;
                } else {
                  throw new Error();
                }

                if (responseFederatedUnits.status === 200) {
                  this.$refs.formDadosCadastrais.federatedUnits =
                    responseFederatedUnits.data.ttUf;
                } else {
                  throw new Error();
                }

                if (responseMaritalStates.status === 200) {
                  this.$refs.formDadosCadastrais.maritalStates =
                    responseMaritalStates.data.ttEstadoCivil;
                } else {
                  throw new Error();
                }

                if (responseLevelsOfEducation.status === 200) {
                  this.$refs.formDadosCadastrais.levelsOfEducation =
                    responseLevelsOfEducation.data.ttGrauInstrucao;
                } else {
                  throw new Error();
                }

                if (responsePersonalData.status === 200) {
                  if (responsePersonalData.data.retorno) {
                    if (
                      responsePersonalData.data.retorno[0].estatus === "Erro"
                    ) {
                      throw new Error(
                        responsePersonalData.data.retorno[0].msgErro
                      );
                    }
                  }

                  this.$refs.formDadosCadastrais.populateEditsFields(
                    responsePersonalData.data.ttDadosCadastrais[0]
                  );

                  this.loadingButton = false;
                  this.mostrarFormDadosCadastrais = true;
                } else {
                  throw new Error();
                }

                this.loadingButton = false;
              }
            )
          );
      } catch (erro) {
        this.loadingButton = false;
        this.$refs.alerta.mostrarMensagem(erro, "red", true);
      }
    },

    async buscaDadosEmpregado() {
      try {
        this.loading = true;

        axios
          .all([
            this.service.buscaDadosPessoais({
              codPessoa: parseInt(localStorage.getItem("codPessoa"))
            }),
            this.service.buscaDadosContratuais({
              codPessoa: parseInt(localStorage.getItem("codPessoa"))
            })
          ])
          .then(
            axios.spread((respostaDadosPessoais, respostaDadosContratuais) => {
              if (respostaDadosPessoais.status === 200) {
                this.popularCardDadosPessoais(respostaDadosPessoais);
              } else {
                throw new Error();
              }

              if (respostaDadosContratuais.status === 200) {
                this.popularCardDadosContratuais(respostaDadosContratuais);
              } else {
                throw new Error();
              }
            })
          );
      } catch (e) {
        console.log("Recebi");
        console.log(e);
      }
    },

    popularCardDadosPessoais(dadosPessoais) {
      try {
        if (dadosPessoais.status === 200) {
          if (dadosPessoais.data.retorno) {
            if (dadosPessoais.data.retorno[0].estatus === "Erro") {
              throw new Error(dadosPessoais.data.retorno[0].msgErro);
            }
          }

          this.txtNome = dadosPessoais.data.ttDadosCadastrais[0].nome;

          var objPhone = {
            key: 0,
            icon: "mdi-phone",
            value: dadosPessoais.data.ttDadosCadastrais[0].fone,
            description: locale[window.local].screen.dadosCadastrais.string007,
            actionIcon: "mdi-message-text"
          };

          var objCellphone = {
            key: 1,
            icon: "mdi-phone",
            value: dadosPessoais.data.ttDadosCadastrais[0].celular,
            description: locale[window.local].screen.dadosCadastrais.string008,
            actionIcon: "mdi-message-text"
          };

          var objEmail = {
            key: 2,
            icon: "mdi-email",
            value: dadosPessoais.data.ttDadosCadastrais[0].emailParticular,
            description: locale[window.local].screen.dadosCadastrais.string009,
          };

          var objAddress = {
            key: 3,
            icon: "mdi-map-marker",
            value:
              dadosPessoais.data.ttDadosCadastrais[0].codTipoLogradouro +
              " " +
              dadosPessoais.data.ttDadosCadastrais[0].endereco +
              ", Nº " +
              dadosPessoais.data.ttDadosCadastrais[0].numEnd +
              ", " +
              dadosPessoais.data.ttDadosCadastrais[0].bairro +
              " " +
              dadosPessoais.data.ttDadosCadastrais[0].complEnd,
            description:
              dadosPessoais.data.ttDadosCadastrais[0].cidade +
              ", " +
              dadosPessoais.data.ttDadosCadastrais[0].codUf +
              " " +
              dadosPessoais.data.ttDadosCadastrais[0].codCep
          };

          var objMaritalStatus = {
            key: 4,
            icon: "mdi-ring",
            value: dadosPessoais.data.ttDadosCadastrais[0].nomeConjuge
              ? dadosPessoais.data.ttDadosCadastrais[0].nomeConjuge +
                " - " +
                dadosPessoais.data.ttDadosCadastrais[0].estadoCivil
              : dadosPessoais.data.ttDadosCadastrais[0].estadoCivil,
            description: locale[window.local].screen.dadosCadastrais.string010,
          };

          var objEducationDegree = {
            key: 5,
            icon: "mdi-school",
            value: dadosPessoais.data.ttDadosCadastrais[0].grauInstrucao,
            description: locale[window.local].screen.dadosCadastrais.string011,
          };

          this.dadosPessoais.push(objPhone);
          this.dadosPessoais.push(objCellphone);
          this.dadosPessoais.push(objEmail);
          this.dadosPessoais.push(objAddress);
          this.dadosPessoais.push(objMaritalStatus);
          this.dadosPessoais.push(objEducationDegree);

          this.loading = false;
        } else {
          throw new Error();
        }
      } catch (e) {
        this.loading = false;
      }
    },
    popularCardDadosContratuais(dadosContratuais) {
      try {
        if (dadosContratuais.status === 200) {
          if (dadosContratuais.data.retorno) {
            if (dadosContratuais.data.retorno[0].estatus === "Erro") {
              throw new Error(dadosContratuais.data.retorno[0].msgErro);
            }
          }

          var objEmpresa = {
            key: 0,
            icon: "mdi-office-building",
            value: dadosContratuais.data.ttDadosContratuais[0].nomeEmpresa,
            description: locale[window.local].screen.dadosCadastrais.string012,
          };

          var objCNPJ = {
            key: 1,
            icon: "mdi-card-text",
            value: dadosContratuais.data.ttDadosContratuais[0].cnpj,
            description: locale[window.local].screen.dadosCadastrais.string013,
          };

          var objCargo = {
            key: 2,
            icon: "mdi-post",
            value: dadosContratuais.data.ttDadosContratuais[0].cargo,
            description: locale[window.local].screen.dadosCadastrais.string014,
          };

          var objUnidade = {
            key: 3,
            icon: "mdi-transit-connection-variant",
            value: dadosContratuais.data.ttDadosContratuais[0].unidade,
            description: locale[window.local].screen.dadosCadastrais.string015,
          };

          var dataFormatada = this.util.formatDate(
            dadosContratuais.data.ttDadosContratuais[0].dtAdmissao
          );

          var objAdmissao = {
            key: 4,
            icon: "mdi-calendar",
            value: dataFormatada,
            description: locale[window.local].screen.dadosCadastrais.string016,
          };

          var objSalario = {
            key: 5,
            icon: "mdi-account-cash",
            value: dadosContratuais.data.ttDadosContratuais[0].vlrSalario,
            description: locale[window.local].screen.dadosCadastrais.string017,
            dinheiro: true
          };

          var objSupervisor = {
            key: 6,
            icon: "mdi-account-supervisor",
            value: dadosContratuais.data.ttDadosContratuais[0].supervisor,
            description: locale[window.local].screen.dadosCadastrais.string018,
          };

          this.dadosContratuais.push(objEmpresa);
          this.dadosContratuais.push(objCNPJ);
          this.dadosContratuais.push(objCargo);
          this.dadosContratuais.push(objUnidade);
          this.dadosContratuais.push(objAdmissao);
          this.dadosContratuais.push(objSalario);
          this.dadosContratuais.push(objSupervisor);
        } else {
          throw new Error();
        }
      } catch (e) {
        this.loading = false;
      }
    },
    atualizarPassos(n) {
      let oldQuantidadePassos = this.quantidadePassos;

      this.quantidadePassos = n;

      if (this.dadosCadastraisFormStep > n) {
        this.dadosCadastraisFormStep = n;
      } else if (this.dadosCadastraisFormStep === 2) {
        if (oldQuantidadePassos === 2 && n === 3) {
          this.dadosCadastraisFormStep = 2;
        } else if (oldQuantidadePassos === 3 && n === 2) {
          this.dadosCadastraisFormStep = 1;
        }
      }
    },

    async buscaBeneficios() {
      const response = await this.service.getBeneficios()
      this.beneficios = response?.data?.Beneficio ?? []
      this.dialogBeneficios = true
    }
  },
  computed: {
    cardWidth() {
      //https://stackoverflow.com/questions/57041559/vuetify-breakpoints-for-columns
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          this.atualizarPassos(3);
          return "400px";
        case "md":
          this.atualizarPassos(3);
          return "500px";
        case "lg":
          this.atualizarPassos(2);
          return "800px";
        case "xl":
          this.atualizarPassos(2);
          return "1000px";
        default:
          this.atualizarPassos(3);
          return "400px";
      }
    }
  }
};
</script>
